import { semanticColors } from "@louise/theme/tokens";

export const factsheetSurfaceColors = {
  instructionBorder: semanticColors.border.subtle,
  instructionBackground: semanticColors.surface.glass,
  instructionDivider: semanticColors.border.subtle,
  brandTagBackground: semanticColors.surface.muted,
  disclaimerDivider: semanticColors.border.subtle,
} as const;
